import React, { FunctionComponent } from "react";
import { Box, Chip, Typography } from "@mui/material";
import { ChatSelectedDocument } from "../../context/ChatContext";
import {
	colorGrayLight,
	grayscaleBg,
	grayscaleGrayDark,
	grayscaleText,
} from "../../styles/theme";
import ChatbotIcon from "../Icons/ChatbotIcon";

interface DocumentSelectionFooterProps {
	selectedDocuments: ChatSelectedDocument[];
	onRemoveDocument: (documentId: number) => void;
}

const DocumentSelectionFooter: FunctionComponent<
	DocumentSelectionFooterProps
> = ({ selectedDocuments, onRemoveDocument }) => {
	return (
		<Box
			sx={{
				padding: "10px 16px",
				borderTop: `1px solid ${colorGrayLight}`,
				display: "flex",
				flexDirection: "column",
				gap: "6px",
			}}
		>
			<Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
				<ChatbotIcon sx={{ width: 16, height: 16, color: grayscaleGrayDark }} />
				<Typography variant="caption" sx={{ opacity: 0.8 }}>
					{selectedDocuments.length
						? `Asking about ${selectedDocuments.length} document${
								selectedDocuments.length > 1 ? "s" : ""
						  }`
						: 'Use "Add to chat" on a card to ask about specific documents'}
				</Typography>
			</Box>
			{Boolean(selectedDocuments.length) && (
				<Box
					sx={{
						display: "flex",
						flexWrap: "wrap",
						gap: "6px",
						maxHeight: "90px",
						overflowY: "auto",
					}}
				>
					{selectedDocuments.map((document) => (
						<Chip
							key={document.id}
							label={document.title}
							size="small"
							sx={{
								maxWidth: "100%",
								backgroundColor: grayscaleBg,
								color: grayscaleText,
								"& .MuiChip-deleteIcon": {
									color: grayscaleText,
									opacity: 0.7,
									"&:hover": { color: grayscaleText, opacity: 1 },
								},
							}}
							onDelete={() => onRemoveDocument(document.id)}
						/>
					))}
				</Box>
			)}
		</Box>
	);
};

export default DocumentSelectionFooter;
